<template>
  <div class="searchHarm regulations">
    <top :toolSort="toolSort"></top>


    <div class="home">
      <div class="main">

        <div class="content " >
        <header>
          <div class="filterDv">
            <el-input v-model="keyWord" size="small" placeholder="关键字查询(可使用空格区分进行多词联查)" clearable
              @keypress.enter.native="getList"  @clear="getList" >
               <i
                 class="el-icon-search"
                 slot="suffix"
                 @click="getList">
               </i>
              </el-input>

              <!-- 选项卡 -->
            <el-checkbox-group v-model="checkList" @change="getList" fill="#78b300">
              <el-checkbox fill="#78b300" :label="n+1" v-for="(item, n) in category" :key="n+1">{{item}}</el-checkbox>
            </el-checkbox-group>

          </div>
        </header>

        <div v-if="key" class="contentWrap scroll_area" :key="componentKey">
          <div v-for="(item,index) in lists" :key="index">
            <div v-if="show(index)" class="title1">
                <span v-html="keyWords(item.name+'【'+item.revisionTime+'】')" @click="tiaozhuan(item)"></span>
            </div>
            <p class="txt" @click="tiaozhuan(item._id, index)" :id="'article_'+index">
              <span v-html="keyWords(item.content)"></span>
            </p>
          </div>
        </div>
        <ol v-else class="scroll_area">
          <li v-for="item in lists" :key="item._id">
            <router-link :to="{name:'detail', query: { id: item._id }}">{{ item.name }}
              【{{item.revisionTime}}】</router-link>
          </li>
        </ol>

                </div>

      </div>

    </div>
  </div>

</template>
<script>
  import top from '../subComponents/top.vue'
  export default {
    data() {
      return {
        category: ['法律', '行政法规', '部门规章', '政策规范性及其他文件', '标准'],
        checkList: [1, 2, 3, 4, 5],
        keyWord: '',
        lists: [],
        key: false, // 结果是否有关键字查询
        componentKey: 0, // 更改 key 以强制重新渲染组件
        toolSort: '',

      }
    },
    components: {
      top,
    },
    watch: {

    },
    async created() {
      this.toolSort = this.$route.params.sort
      this.getList()



    },
    computed:{
        show: function(){
          return (index) => {
            let flag = true;
            if(index > 0 && this.lists[index]._id == this.lists[index-1]._id){
              flag = false;
            }
            return flag;
          }
        }
      },
    methods: {
      tiaozhuan(itemId,index){
        const content = document.querySelector('#article_'+index).innerText;
        this.$router.push({name:'detail', query: { id:itemId,content}})

      },
     async getList() {
        this.$axios.post(this.$serviceAPI.getRegulationsList, {
        keyWord: this.keyWord,
        type: this.checkList,
        status: 1, // 已上线的
        }).then(res => {
          this.lists = res.data.data || [];
        })
        this.key = !!this.keyWord;
        this.componentKey+=1;

      },
      toDetail(item){
            let routeUrl = this.$router.push({
              name:'detail',
              query: { id: item._id, content: item.article.sections.content }
            });
            window.open(routeUrl.href, '_blank'); // 在新窗口打开
          },


       keyWords(str){
            if(!str) return '';
            const keyWords = this.keyWord.trim().split(' ');
            if(str && str.length > 50){
              const arr = str.split(`\n`).filter(ele => {
                return keyWords.every(key => ele.includes(key))
              });
              str = arr[0] || '';
              if(!/.*[\u4e00-\u9fa5]+.*$/.test(str)){ // 不含汉子的字符串
                return '';
              }
            }
            const regex = keyWords.map(k => {
              return '('+k.trim()+')';
            }).join('|');
            const reg = new RegExp(regex, 'gi');
            const newStr = str.replace(reg, "<font color=#50a4fc>"+keyWords.map((_,i) => '$'+(i+1)).join('')+"</font>");
            return newStr;
          },

}




  }
</script>

<style>
.main {
  background-color: #f2f4f7;
  padding: 20px 20px 10px;
  box-sizing: border-box;
  border-radius: 2px;
}
.main .scroll_area {
  height: calc(100vh - 320px);
  overflow-y: scroll;
}

.el-checkbox-group {
  display: inline-block;
}
.el-checkbox-group .el-checkbox {
  font-weight: bold;
  color: #666;
}
.el-input__suffix{
  right: 12px;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  font-weight: bold;
}
.el-icon-search{
  font-size: ;
}
.contentWrap {
  height: calc(100vh - 200px);
  margin-top: 10px;
  overflow-y: scroll;
}
.contentWrap .title1 a {
  color: #0063e0;
  font-size: 17px;
  font-weight: bold;
  margin: 15px 0 10px;
  text-decoration: underline;
}
.contentWrap .txt {
  font-size: 14px;
  color: #666;
  text-indent: 2px;
  line-height: 1.5em;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}
.contentWrap .txt span {
  /* margin-left: 10px; */
  font-weight: normal;
}
.contentWrap .txt:hover {
  cursor: pointer;
  color: #50a4fc;
  text-decoration: underline;
}

ol li {
  color: #333;
  padding: 0 10px;
  line-height: 32px;
}
ol li .updateTime {
  float: right;
  font-size: 13px;
  color: #999;
}
ol li a,
ol li a:hover {
  text-decoration: none;
  font-size: 16px;
   color: #333;

}

.btnDv {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.regulations .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #444;
}

.regulations .el-checkbox__input.is-checked .el-checkbox__inner,
.regulations .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #78b300;
  border-color: #78b300;
}

.regulations .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #DCDFE6;
}

.home {
  width: 100%;
  margin: 10px auto;
  margin-left: 0px;
}

.addBtn {
  margin: 10px 0;
}

.header {
  margin: 0px 0 10px;
}

header {
  display: flex;
  justify-content: space-between;
}

.filterDv {
  font-size: 14px;
}
.filterDv .el-input  {
  display: inline-block;
  width: 300px;
  margin-right: 20px;
  margin-bottom: 15px;
}
.filterDv .el-select {
  display: inline-block;
  width: 180px;
}

.pagination {
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/subPage/regulations.vue